export const API_KEY = 'AIzaSyDprCtO8xDJhkIYThX8TVD5A3362pQi1T4';